import type { ApiErrorBody } from "./types";

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

export function setLocalAdminKey(value: string) {
  if (value) sessionStorage.setItem("ocr.adminKey", value);
  else sessionStorage.removeItem("ocr.adminKey");
}
export function hasLocalAdminKey() {
  return Boolean(sessionStorage.getItem("ocr.adminKey"));
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const key = sessionStorage.getItem("ocr.adminKey");
  if (key) headers.set("X-Admin-Key", key);
  if (init.body && !headers.has("Content-Type"))
    headers.set("Content-Type", "application/json");
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "same-origin",
  });
  const contentType = response.headers.get("content-type") ?? "";
  const body = contentType.includes("application/json")
    ? await response.json()
    : await response.text();
  if (!response.ok) {
    const error = body as ApiErrorBody;
    throw new ApiError(
      response.status,
      error.error?.code ?? "REQUEST_FAILED",
      error.error?.message ?? String(body),
    );
  }
  return body as T;
}
export async function apiBlob(path: string): Promise<Blob> {
  const headers = new Headers();
  const key = sessionStorage.getItem("ocr.adminKey");
  if (key) headers.set("X-Admin-Key", key);
  const response = await fetch(path, { headers, credentials: "same-origin" });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = (await response.json()) as ApiErrorBody;
      message = body.error?.message ?? message;
    } catch {
      message = `Request failed (${response.status})`;
    }
    throw new ApiError(response.status, "REQUEST_FAILED", message);
  }
  return response.blob();
}
export const jsonBody = (value: unknown) => JSON.stringify(value);
